import React, { useState } from 'react';
import { Button, Input, Form, Row, Col, Typography, DatePicker } from 'antd';
import { SearchOutlined, DeleteOutlined } from '@ant-design/icons';
import { TableCustom } from '../../../components/TableCustom';
import { useQuery } from '@tanstack/react-query';
import { getListMbPushNotiTransactionsRequest } from '../../../services/cms/mbPushNotiTransactionServiceRequest';
import { newObjectKeys } from '../../../utils/utility';
import moment from 'moment';
import dayjs from 'dayjs';

const { Text } = Typography;
const { RangePicker } = DatePicker;

const QuanLyMbPushBDSD = () => {
  const [formSearch] = Form.useForm();
  const [params, setParams] = useState({ page: 1, limit: 20 });

  const { data: dataTransactions, isLoading } = useQuery({
    queryKey: ['dataMbPushNotiTransactions', params],
    queryFn: () => getListMbPushNotiTransactionsRequest(params),
  });

  const handleSubmitForm = (values) => {
    const temp = { page: 1, limit: params.limit };
    if (values?.textSearch) temp.textSearch = values.textSearch;
    if (values?.createTimeRange && values.createTimeRange.length === 2) {
      temp.createTimeFrom = values.createTimeRange[0].format('YYYY-MM-DD');
      temp.createTimeTo = values.createTimeRange[1].format('YYYY-MM-DD');
    }
    if (values?.transDateRange && values.transDateRange.length === 2) {
      temp.transDateFrom = values.transDateRange[0].format('YYYY-MM-DD');
      temp.transDateTo = values.transDateRange[1].format('YYYY-MM-DD');
    }
    setParams(temp);
  };

  const hasFilter = params && Object.values(
    newObjectKeys(params, ['textSearch', 'createTimeFrom', 'createTimeTo', 'transDateFrom', 'transDateTo'])
  ).some((value) => value);

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 60 },
    {
      title: 'Thời gian nhận', dataIndex: 'create_time', key: 'create_time', width: 160,
      render: (val) => val ? moment(val).format('DD/MM/YYYY HH:mm:ss') : '--',
    },
    {
      title: 'Thời gian thanh toán', dataIndex: 'transaction_datetime', key: 'transaction_datetime', width: 160,
      render: (val) => val ? moment(val).format('DD/MM/YYYY HH:mm:ss') : '--',
    },
    { title: 'Nội dung', dataIndex: 'content', key: 'content', ellipsis: true },
    { title: 'Mã giao dịch', dataIndex: 'referencenumber', key: 'referencenumber', width: 160 },
    {
      title: 'Số tiền', dataIndex: 'amount', key: 'amount', width: 120,
      render: (val) => val ? Number(val).toLocaleString() : '--',
    },
    {
      title: 'PremiumOrderId', dataIndex: 'premium_order_id', key: 'premium_order_id', width: 130,
      render: (val) => val ? (
        <a href={`/cms/quan-ly-don-hang?title=${val}`} target="_blank" rel="noopener noreferrer">{val}</a>
      ) : '--',
    },
  ];

  return (
    <div className="m-5">
      <div className="flex justify-between items-center mb-5">
        <h1 className="text-2xl">MB push BDSD</h1>
      </div>
      <Form name="search_mb_push" form={formSearch} layout="vertical" requiredMark={false} className="mb-5" onFinish={handleSubmitForm}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} xl={6}>
            <Form.Item name="textSearch" label={<Text>Tìm kiếm</Text>}>
              <Input placeholder="Nội dung, mã GD, số tiền, order ID..." />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} xl={6}>
            <Form.Item name="createTimeRange" label={<Text>Ngày nhận</Text>}>
              <RangePicker format="DD/MM/YYYY" style={{ width: '100%' }} placeholder={['Từ ngày', 'Đến ngày']} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} xl={6}>
            <Form.Item name="transDateRange" label={<Text>Ngày thanh toán</Text>}>
              <RangePicker format="DD/MM/YYYY" style={{ width: '100%' }} placeholder={['Từ ngày', 'Đến ngày']} />
            </Form.Item>
          </Col>
          <Col className="flex items-center gap-2">
            <Button type="primary" htmlType="submit"><SearchOutlined /> Tìm kiếm</Button>
            {hasFilter && (
              <Button htmlType="button" onClick={() => { formSearch.resetFields(); setParams({ page: 1, limit: params.limit }); }}>
                <DeleteOutlined /> Xóa lọc
              </Button>
            )}
          </Col>
        </Row>
      </Form>
      <TableCustom columns={columns} dataSource={dataTransactions?.data} totalItem={dataTransactions?.total}
        params={params} setParams={setParams} loading={isLoading} scroll={{ x: 900 }} />
    </div>
  );
};

export default QuanLyMbPushBDSD;

